/**
 * Cases
 */
export const INBOX_FETCH_CASES_REQUESTED = 'INBOX_FETCH_CASES_REQUESTED'
export const INBOX_FETCH_CASES_SUCCESS = 'INBOX_FETCH_CASES_SUCCESS'
export const INBOX_FETCH_CASES_FAILED = 'INBOX_FETCH_CASES_FAILED'

export const INBOX_ADD_TO_CASE_REQUESTED = 'INBOX_ADD_TO_CASE_REQUESTED'
export const INBOX_ADD_TO_CASE_SUCCESS = 'INBOX_ADD_TO_CASE_SUCCESS'
export const INBOX_ADD_TO_CASE_FAILED = 'INBOX_ADD_TO_CASE_FAILED'

export const INBOX_CASES_RESET = 'INBOX_CASES_RESET'

export const INBOX_SET_FOR_CASE_REQUESTED = 'INBOX_SET_FOR_CASE_REQUESTED'
export const INBOX_SET_FOR_CASE_SUCCESS = 'INBOX_SET_FOR_CASE_SUCCESS'
export const INBOX_SET_FOR_CASE_ERROR = 'INBOX_SET_FOR_CASE_ERROR'

/**
 * Add/remove labels
 */
export const INBOX_HANDLE_MARKED_LABELS_LIST = 'INBOX_HANDLE_MARKED_LABELS_LIST'
export const INBOX_RESET_MARKED_LABELS = 'INBOX_RESET_MARKED_LABELS'
export const INBOX_ADD_MARKED_LABELS_REQUESTED =
  'INBOX_ADD_MARKED_LABELS_REQUESTED'
export const INBOX_ADD_MARKED_LABELS_SUCCESS = 'INBOX_ADD_MARKED_LABELS_SUCCESS'
export const INBOX_ADD_MARKED_LABELS_ERROR = 'INBOX_ADD_MARKED_LABELS_ERROR'

export const INBOX_SET_ADDED_LABELS_REQUESTED =
  'INBOX_SET_ADDED_LABELS_REQUESTED'
export const INBOX_SET_ADDED_LABELS_SUCCESS = 'INBOX_SET_ADDED_LABELS_SUCCESS'

export const INBOX_REMOVE_LABEL_REQUESTED = 'INBOX_REMOVE_LABEL_REQUESTED'
export const INBOX_REMOVE_LABEL_SUCCESS = 'INBOX_REMOVE_LABEL_SUCCESS'
export const INBOX_REMOVE_LABEL_ERROR = 'INBOX_REMOVE_LABEL_ERROR'
